// utils/idleCallback.ts — tunda kerja non-kritis sampai browser idle (fallback timeout).
export function onIdle(fn: () => void, timeoutMs: number): () => void {
    if (typeof window !== 'undefined' && typeof (window as any).requestIdleCallback === 'function') {
        const id = (window as any).requestIdleCallback(fn, { timeout: timeoutMs });
        return () => (window as any).cancelIdleCallback?.(id);
    }
    const t = window.setTimeout(fn, Math.min(timeoutMs, 2000));
    return () => window.clearTimeout(t);
}
